import {
  Box, Card, Grid, Skeleton, Theme, ThemeProvider, useTheme,
} from '@mui/material';
import { SxProps } from '@mui/system';
import { useIsMobile } from '../../../common/hooks/useResponsive';
import { ContentTheme } from './ContentTheme';

interface ContentCardSkeletonProps {
  sx?: SxProps<Theme>
}

export default function ContentHorizontalCardSkeleton(props: ContentCardSkeletonProps) {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const numberOfCards = 5;
  return (
    <ThemeProvider theme={ContentTheme}>
      {[...Array(numberOfCards).keys()].map((item, index) => (
        <Grid item key={index}
          sx={{
            paddingTop: theme.spacing(0),
            paddingLeft: theme.spacing(0),
            [theme.breakpoints.down('md')]: {
              paddingTop: theme.spacing(0),
            },
            [theme.breakpoints.up('md')]: {
              width: '100%',
            },
            ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
          }}
        >
          <Card
            sx={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              width: '100%',
              borderRadius: ContentTheme.spacing(1.25),
              boxShadow: 0,
              padding: ContentTheme.spacing(1.5),
              gap: ContentTheme.spacing(2),
            }}
          >
            <Skeleton
              animation="wave"
              variant="rectangular"
              height={220}
              sx={{
                width: isMobile ? '100%' : 400,
                borderRadius: ContentTheme.spacing(1.25),
              }}
            />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                width: '80%',
              }}
            >
              <Skeleton animation="wave" height={20} width="40%" sx={{ mb: 1 }} />
              <Skeleton animation="wave" height={40} width="80%" sx={{ mb: 1 }} />
              <Skeleton animation="wave" height={80} width="100%" sx={{ mb: 3 }} />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  width: '100%',
                  minWidth: ContentTheme.spacing(28),
                }}
              >
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={40}
                  height={40}
                  sx={{ borderRadius: ContentTheme.spacing(1.25) }}
                />
                <Skeleton animation="wave" height={15} width="30%" sx={{ ml: 2 }} />
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={40}
                  height={40}
                  sx={{ borderRadius: ContentTheme.spacing(1.25), alignSelf: 'flex-end', marginLeft: 'auto' }}
                />
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={40}
                  height={40}
                  sx={{ borderRadius: ContentTheme.spacing(1.25), alignSelf: 'flex-end', marginLeft: ContentTheme.spacing(1) }}
                />
              </Box>
            </Box>
          </Card>
        </Grid>
      ))
      }
    </ThemeProvider >);
}
